import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, saveToken } from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

export default function AuthCallback() {
    const nav = useNavigate();
    const { setUser } = useAuth();
    const processed = useRef(false);
    const [err, setErr] = useState("");

    useEffect(() => {
        if (processed.current) return;
        processed.current = true;
        const hash = window.location.hash || "";
        const m = hash.match(/session_id=([^&]+)/);
        if (!m) { nav("/login"); return; }
        const sessionId = decodeURIComponent(m[1]);
        // Role, signup_source & referral code may arrive via query string
        // (survives cross-origin redirects) or sessionStorage (same-origin flow).
        const qs = new URLSearchParams(window.location.search || "");
        const pendingRole = qs.get("role") || sessionStorage.getItem("vu_pending_role") || null;
        const pendingSource = qs.get("source") || sessionStorage.getItem("vu_pending_source") || null;
        const pendingRef = qs.get("ref") || sessionStorage.getItem("vu_pending_ref") || null;
        sessionStorage.removeItem("vu_pending_role");
        sessionStorage.removeItem("vu_pending_source");
        sessionStorage.removeItem("vu_pending_ref");
        (async () => {
            try {
                const { data } = await api.post("/auth/google/process", {
                    session_id: sessionId, role: pendingRole, signup_source: pendingSource, ref: pendingRef,
                });
                if (data.token) saveToken(data.token);
                setUser(data);
                // strip hash
                window.history.replaceState(null, "", "/");
                if (!data.role) nav("/choose-role"); else nav("/dashboard");
            } catch (e) {
                setErr("Google sign-in failed. " + (e.response?.data?.detail || e.message));
                setTimeout(() => nav("/login"), 2500);
            }
        })();
    }, [nav, setUser]);

    return (
        <div className="min-h-screen grid place-items-center grain" data-testid="auth-callback">
            <div className="card-warm p-7 max-w-sm text-center">
                <div className="font-serif text-xl mb-1">Welcoming you in…</div>
                <div className="text-sm text-[var(--text-ink)]/65">Verifying your Google sign-in.</div>
                {err && <div className="text-sm text-[var(--status-red)] mt-3">{err}</div>}
            </div>
        </div>
    );
}
